import { FC } from 'react';
import { TabChipsProps } from './TabChips.types';
import { Container } from './TabChips.styles';
import { AllieChip, AllieChipColorProps } from '../../../../../components/Chip';
import { AllieColors } from '../../../../../common/color.types';
import { capitalize } from '../../../../../common/utils';

const colors: {
  active: AllieChipColorProps;
  outline: AllieChipColorProps;
} = {
  active: {
    backgroundColor: 'primary-80' as AllieColors,
    allieColor: 'white' as AllieColors,
    borderColor: 'primary-80' as AllieColors,
  },
  outline: {
    backgroundColor: 'neutral-5' as AllieColors,
    allieColor: 'primary-90' as AllieColors,
    borderColor: 'neutral-30' as AllieColors,
  },
};

export const TabChips: FC<TabChipsProps> = ({
  tabs,
  selectedTab,
  onTabChange,
}) => {
  return (
    <Container>
      {tabs.map((tab) => {
        const isSelected = selectedTab === tab.value;
        const chipColor = isSelected ? colors.active : colors.outline;

        return (
          <AllieChip
            key={tab.value}
            color={chipColor}
            radius="full"
            onClick={() => onTabChange(tab.value)}
            style={{ margin: '0' }}
          >
            {capitalize(tab.label)}
          </AllieChip>
        );
      })}
    </Container>
  );
};
